import { FC, useState } from 'react'
import { DatePicker, Card, ConfigProvider } from 'antd'
import type { DatePickerProps } from 'antd'
import { CalendarOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import enUS from 'antd/es/locale/en_US'

interface DateSelectorProps {
  onDateChange: (date: string) => void // Returns: YYYY-MM-DD
  loading?: boolean
}

export const DateSelector: FC<DateSelectorProps> = ({
  onDateChange,
  loading = false
}) => {
  const [selectedDate, setSelectedDate] = useState(dayjs())

  const handleDateChange: DatePickerProps['onChange'] = (date) => {
    if (date) {
      console.log(`📅 DateSelector: User selected date: ${date.format('YYYY-MM-DD')}`)
      setSelectedDate(date)
      // Simple format as YYYY-MM-DD, no timezone conversion
      const dateString = date.format('YYYY-MM-DD')
      onDateChange(dateString)
    }
  }

  return (
    <Card className='mb-6'>
      <div className='flex items-center space-x-4'>
        <CalendarOutlined className='text-lg text-blue-500' />
        <span className='text-lg font-medium'>เลือกวันที่:</span>
        <ConfigProvider locale={enUS}>
          <DatePicker
            value={selectedDate}
            onChange={handleDateChange}
            format='DD/MM/YYYY'
            placeholder='Select Date'
            disabled={loading}
            allowClear={false}
            className='min-w-[150px]'
          />
        </ConfigProvider>
      </div>
    </Card>
  )
}